import { Provider } from '@angular/core';
import { PaginatedStateLoadingMode } from '@shared/ui';
import { WorkspaceEditorFacade } from './workspace-editor.facade';
import { workspaceFormProviders, workspacesListProviders } from '../../../providers/store.providers';
import { caseTypeStoreProviders } from '@protocols/ui';

export function workspaceEditorFacadeProviders(): Provider[] {
  return [
    ...workspacesListProviders(PaginatedStateLoadingMode.PAGINATED),
    ...workspaceFormProviders(),
    ...caseTypeStoreProviders,
    WorkspaceEditorFacade,
  ];
}
